import { CHARTS_TYPE_ENUM } from "@/enums/charts-type.enum";
import { LineChartGMBModel } from "./line/line-chart-gmb-model";
import { BarChartGMBModel } from "./bar/bar-chart-gmb-model";
import { DoughnutChartGMBModel } from "./doughnut/doughnut-chart-gmb-model";

export class GMBChartsFactory {
  constructor() {
    this.chart = null;
    this._chartConfig = null;
  }

  makeChart({ type, chartConfig }) {
    this._chartConfig = chartConfig;
    switch (type) {
      case CHARTS_TYPE_ENUM.LINE: {
        this.chart = this._createChart(LineChartGMBModel);
        break;
      }
      case CHARTS_TYPE_ENUM.BAR: {
        this.chart = this._createChart(BarChartGMBModel);
        break;
      }
      case CHARTS_TYPE_ENUM.DOUGHNUT: {
        this.chart = this._createChart(DoughnutChartGMBModel);
        break;
      }
    }
  }

  returnChart() {
    return this.chart;
  }

  _createChart(chartModel) {
    const chart = new chartModel();
    chart.makeChart(this._chartConfig);
    return chart.returnChart();
  }
}
